"use client";
import { DropDownIcon } from "@/data/icons";
import { NaveLinks } from "@/data/links";
import Link from "next/link";
import { usePathname } from "next/navigation";
import { useState } from "react";

interface MobileNavProps {
  mobileMenu: boolean;
  setMobileMenu: React.Dispatch<React.SetStateAction<boolean>>;
}
const MobileNav: React.FC<MobileNavProps> = ({ mobileMenu, setMobileMenu }) => {
  const [openDropDown, setOpenDropDown] = useState<number | null>(null);
  const [openSubDropDown, setOpenSubDropDown] = useState<number | null>(null);
  const pathName = usePathname();
  return (
    <div
      className={`fixed top-[13rem] max-lg:block hidden left-0 w-full h-screen z-50 bg-black/80 transition-all duration-300 ${mobileMenu ? "translate-x-0" : "-translate-x-full"}`}
    >
      <div className="w-full h-full relative">
        <div className="w-full h-full bg-white">
          <nav className="flex flex-col gap-2 h-full w-full  pb-4 ">
            <ul className="flex flex-col h-[90dvh] overflow-y-auto pb-36">
              {NaveLinks.map((link, index) => {
                return (
                  <li key={index} className={` text-[#29313C] py-3 px-4 capitalize flex flex-col `}>
                    <span className="flex items-center justify-between">
                      <Link
                        href={link.href ? link.href : "/"}
                        onClick={() => setMobileMenu(false)}
                        className="w-4/5 !text-base capitalize  font-semibold"
                      >
                        {link.name}
                      </Link>

                      {link.subLinks && (
                        <button
                          type="button"
                          onClick={() =>
                            setOpenDropDown(
                              openDropDown === index ? null : index
                            )
                          }
                          className="flex items-center gap-2 w-1/5 justify-center"
                        >
                          <span
                            className={
                              openDropDown === index ? "rotate-180" : ""
                            }
                          >
                            <DropDownIcon />
                          </span>
                        </button>
                      )}
                    </span>

                    {link.subLinks && openDropDown === index && (
                      <span className="flex flex-col gap-4 mt-4 ml-2">
                        {link.subLinks.map((subLink, subIndex) => (
                          <span key={subIndex} className="flex flex-col gap-2">
                            <span className="flex items-center justify-between">
                              <Link
                                href={subLink.href ? subLink.href : "/"}
                                onClick={() => {
                                  setMobileMenu(false);
                                  setOpenSubDropDown(null);
                                }}
                                className={`w-4/5  font-semibold ${pathName === subLink.href ? "text-secondary" : ""} capitalize text-sm`}
                              >
                                {subLink.name}
                              </Link>
                              {subLink.subLinks && (
                                <button
                                  type="button"
                                  onClick={() =>
                                    setOpenSubDropDown(
                                      openSubDropDown === subIndex
                                        ? null
                                        : subIndex
                                    )
                                  }
                                  className="flex items-center gap-2 w-1/5 justify-center"
                                >
                                  <DropDownIcon />
                                </button>
                              )}
                            </span>
                            {subLink.subLinks &&
                              openSubDropDown === subIndex && (
                                <span className="flex flex-col gap-3 ml-4">
                                  {subLink.subLinks.map(
                                    (subSubLink, subSubIndex) => (
                                      <Link
                                        key={subSubIndex}
                                        href={
                                          subSubLink.href
                                            ? subSubLink.href
                                            : "/"
                                        }
                                        onClick={() => {
                                          setMobileMenu(false);
                                          setOpenSubDropDown(null);
                                        }}
                                        className={`w-5/6 ${pathName === subSubLink.href ? "text-secondary" : ""} capitalize text-sm`}
                                      >
                                        {subSubLink.name}
                                      </Link>
                                    )
                                  )}
                                </span>
                              )}
                          </span>
                        ))}
                      </span>
                    )}
                  </li>
                );
              })}
            </ul>
          </nav>
        </div>
      </div>
    </div>
  );
};

export default MobileNav;
